import accessAuth from "./AuthControl"
import accessDashboard from "./DashboardControl"
import accessMaster from "./MasterControl"
import accessUsers from "./UsersControl"
import accessSettings from "./SettingsControl"
import accessVendor from "./VendorControl"
import accessSubscription from "./SubscriptionControl"
import accessShop from "./ShopControl"

const RoutesMap = {
    ...accessAuth,
    ...accessDashboard,
    ...accessMaster,
    ...accessSettings,
    ...accessUsers,
    ...accessVendor,
    ...accessSubscription,
    ...accessShop,
}

export default RoutesMap;